type EventCallback = (message: string | null) => void;
export default class Stream {
  //TODO CHANGE WHEN ERROR ON BACKEND READY
  private readonly ERROR_MESSAGE = '[ERROR] 429_TOO_MANY_REQUESTS';
  private readonly DONE_MESSAGE = '[DONE]';

  private instance: EventSource | undefined;
  private apiUrl!: string;
  private message = '';
  constructor(
    surveyId: string,
    elementId: number,
    streamEnabled: boolean = true
  ) {
    this.apiUrl = `${process.env.VUE_APP_GPT_URL}/generate-review/${elementId}/surveys/${surveyId}/?stream=${streamEnabled}`;
  }

  connect() {
    this.instance = new EventSource(this.apiUrl);
  }

  onError(errorHandler: () => void) {
    this.instance!.onerror = errorHandler;
  }
  onMessage(callback: EventCallback) {
    return new Promise((resolve, reject) => {
      this.instance!.onmessage = (event: MessageEvent) => {
        this.verifyOrigin(event.origin);
        if (event.data.trim() === this.DONE_MESSAGE) {
          resolve('Success');
          this.close();
          return;
        }

        this.message += event.data;
        callback(this.message);
        if (event.data.trim() === this.ERROR_MESSAGE) {
          reject('Error');
          return;
        }
      };
    });
  }

  close() {
    this.instance?.close();
  }

  private verifyOrigin(origin: string) {
    const apiUrl = new URL(process.env.VUE_APP_GPT_URL);

    if (apiUrl.origin !== origin) {
      this.close();
      console.error('Wrong origin');
      return;
    }
  }
}
